module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-heart-out-4d8012c4052f3b73de0c920939758044.svg";